// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2xdkG","content":"LayoutSettings_content__2Wo8Y"};